import React, { useState, useRef } from 'react';
import ReportingProductsOptionDropdown from './ReportingProductsOptionDropdown'
import ReportTimePeriodDropDown from './ReportTimePeriodDropDown'
import ReportGeographyDropDown from './ReportGeographyDropDown'
import ReportMessagesDropDown from './ReportMessagesDropDown'
import ToastAlert from '../ToastAlert';
import PropType from 'prop-types';

UtilizationReportingFilters.propTypes = {
    isGeographyMenuEnabled: PropType.bool,
    isMessageMenuEnabled: PropType.bool,
    setFilterState: PropType.func,
    filterState: PropType.object
}


function UtilizationReportingFilters(props) {
    const {
        setFilterState,
        filterState,
        isGeographyMenuEnabled,
        isMessageMenuEnabled
    } = props; 

    const [showToast, setShowToast] = useState(false);
    const [toastTitle, setToastTitle] = useState("");
    const [toastMessage, setToastMessage] = useState("");
    const [isTimeRangeMenuVisible, setIsTimeRangeMenuVisible] = useState(false);
    const [isGeographyMenuVisible, setIsGeographyMenuVisible] = useState(false);
    const [isMessagesMenuVisible, setIsMessagesMenuVisible] = useState(false);
    const timeRangeMenuRef = useRef(null);
	const timeRangeMenuContentRef = useRef(null);
    const [isProductsMenuVisible, setIsProductsMenuVisible] = useState(false);
    const productsMenuRef = useRef(null);
    const productsMenuContentRef = useRef(null);
    const geographyMenuRef = useRef(null);
   	const geographyMenuContentRef = useRef(null);
    const messageMenuRef = useRef(null);
   	const messageMenuContentRef = useRef(null);

    function closeOpenProductsMenus(event) {
		// click outside of menus and content menus = close menus
		if (
			productsMenuRef.current &&
			!productsMenuRef.current.contains(event.target) &&
			!productsMenuContentRef.current.contains(event.target) &&
			isProductsMenuVisible
		) {
			setIsProductsMenuVisible(false);
		}
	}
	document.addEventListener('mousedown', closeOpenProductsMenus);

    function closeOpenTimeRangeMenus(event) {
		// click outside of menus and content menus = close menus
		if (
			timeRangeMenuRef.current &&
			!timeRangeMenuRef.current.contains(event.target) &&
			!timeRangeMenuContentRef.current.contains(event.target) &&
			isTimeRangeMenuVisible
		) {
			setIsTimeRangeMenuVisible(false);
		}
	}
    document.addEventListener('mousedown', closeOpenTimeRangeMenus);

    function closeGeographyTimeRangeMenus(event) {
		// click outside of menus and content menus = close menus
		if (
			geographyMenuRef.current &&
			!geographyMenuRef.current.contains(event.target) &&
			!geographyMenuContentRef.current.contains(event.target) &&
			isGeographyMenuVisible
		) {
			setIsGeographyMenuVisible(false);
		}
	}
    document.addEventListener('mousedown', closeGeographyTimeRangeMenus);

    function closeMessageTypesMenus(event) {
        if (
			messageMenuRef.current &&
			!messageMenuRef.current.contains(event.target) &&
			!messageMenuContentRef.current.contains(event.target) &&
			isMessagesMenuVisible
		) {
			setIsMessagesMenuVisible(false);
		}
	}
    document.addEventListener('mousedown', closeMessageTypesMenus);
    
    function triggerToastAlert(title, message) {
        setToastTitle(title);
        setToastMessage(message);
        setShowToast(true);
    }

    return (
        <div className='d-flex flex-row'>    
         
            <ReportTimePeriodDropDown
                isEnabled={true}
                isMenuVisible = {isTimeRangeMenuVisible}
                menuContentRef={timeRangeMenuContentRef}
                menuRef={timeRangeMenuRef}
                setIsMenuVisible={setIsTimeRangeMenuVisible}
                filterState={filterState}
                setFilterState={setFilterState}
            ></ReportTimePeriodDropDown>
            <ReportingProductsOptionDropdown
                isEnabled={true}
                isMenuVisible = {isProductsMenuVisible}
                menuContentRef={productsMenuContentRef}
                menuRef={productsMenuRef}
                setIsMenuVisible={setIsProductsMenuVisible}
                filterState={filterState}
                setFilterState={setFilterState}
                triggerToastAlert={triggerToastAlert}
            ></ReportingProductsOptionDropdown>
            <ReportGeographyDropDown
                isEnabled={isGeographyMenuEnabled}
                isMenuVisible = {isGeographyMenuVisible}
                menuContentRef={geographyMenuContentRef}
                menuRef={geographyMenuRef}
                setIsMenuVisible={setIsGeographyMenuVisible}              
                filterState={filterState}
                setFilterState={setFilterState}
            ></ReportGeographyDropDown>      
            <ReportMessagesDropDown
                isEnabled={isMessageMenuEnabled}
                isMenuVisible = {isMessagesMenuVisible}   
                menuContentRef={messageMenuContentRef}      
                menuRef={messageMenuRef}
                setIsMenuVisible={setIsMessagesMenuVisible}
                filterState={filterState}
                setFilterState={setFilterState}
            ></ReportMessagesDropDown>    
            <ToastAlert
                show={showToast}
                setShow={setShowToast}
                title={toastTitle}
                message={toastMessage}
            />
        </div>
    );
}

export default UtilizationReportingFilters;
